import ApplicationController from './application_controller'
import { copyTextToClipboard } from '../utils'

class Copy2clipboardController extends ApplicationController {
  connect () {
    this.element.addEventListener('click', (e) => {
      copyTextToClipboard(e.target.dataset.value)
    })
  }
}

export default Copy2clipboardController
